<template>
  <div class="bundles container">
    <div class="headerbar flex-m items-start mb5 f-body">
      <div v-show="isLoading" class="f8 info">{{ $t('Loading...') }}</div>
      <div v-show="!isLoading" class="f8 info">{{ bundles.length }} {{ $tc('bundle added | bundles added', bundles.length) }}</div>
      <UIButton primary :to="{ name: 'new-bundle' }">{{ $t('Add Bundle') }}</UIButton>
    </div>

    <UIGridIndexLoader v-if="isLoading" />

    <div
      v-if="!isLoading && !noBundles"
      class="bundleslist"
      :class="{ '-morethanthree': bundles.length > 3 }">
      <BundleCard
        v-for="bundle of bundles"
        :key="bundle.id"
        :bundle="bundle"
        @click.native="navigateToBundle(bundle)"
      />
    </div>

    <div class="empty f-body tc w-70 center fill-geyser fadeIn animated" v-if="noBundles">
      <UIIcon name="headset" class="dib mv5" style="width:8rem;"/>
      <i18n
        tag="p"
        path="You don't have any bundles yet. Click on {newBundleLink} to begin."
      >
        <router-link
          slot="newBundleLink"
          class="link-style"
          :to="{ name: 'new-bundle' }"
        >{{ $t('Add Bundle') }}</router-link>
      </i18n>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import Panel from '@/core/shared/components/Panel';
import UIButton from '@/core/shared/components/ui/UIButton';
import UIIcon from '@/core/shared/components/ui/UIIcon';
import UIGridIndexLoader from '@/core/shared/components/ui/UIGridIndexLoader';
import BundleCard from './BundleCard';

@Component({
  components: {
    Panel,
    BundleCard,
    UIButton,
    UIIcon,
    UIGridIndexLoader,
  },
})
export default class Bundles extends Vue {
  get isLoading () {
    return this.$store.state.bundles.isFetchingBundles && this.bundles.length === 0;
  }

  get noBundles () {
    return !this.$store.state.bundles.isFetchingBundles && this.bundles.length === 0;
  }

  get bundles () {
    const bundles = this.$store.getters.getAllBundles; // ['entities/Bundle/all'];
    return [...bundles].sort((a, b) => {
      if (a.title < b.title) { return -1; }
      if (a.title > b.title) { return 1; }
      return 0;
    });
  }

  created () {
    this.$store.commit('setTitle', this.$t('Bundles'));
    this.$store.dispatch('getBundles');
  }

  navigateToBundle (bundle) {
    this.$router.push({ name: 'edit-bundle', params: { bundleId: bundle.id } });
  }
}
</script>

<style scoped lang="postcss">
@import "core/shared/styles";

.bundles {
  margin-top: var(--spacingMd);
  & .headerbar {
    align-items: center;

    & .info {
      flex: 1 1 auto;
    }
  }

  & .bundleslist {
    display: grid;

    grid-template-columns: 1fr;
    grid-gap: var(--spacingSm);
    padding-bottom: var(--spacingMd);

    @media (--tablet) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media (--desktop) {
      grid-template-columns: repeat(auto-fit, 33rem);

      &.-morethanthree {
        grid-template-columns: repeat(auto-fit, minmax(27rem, 1fr));
      }
    }
  }
}
</style>
